var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-container"},[(_vm.showIcon)?_c('span',{class:['icon', _vm.type]},[_c('Icon',{attrs:{"name":_vm.iconName}})],1):_vm._e(),_c('span',{class:['text', 'semibold', {'high-emphasis': _vm.isHighEmphasis }, _vm.type]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }